import React, { useEffect } from 'react'

import {
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton
} from '@draft-js-plugins/buttons'

const HeadlinesPicker = props => {
  const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton]
  const onWindowClick = () => props.onOverrideContent(undefined)

  useEffect(() => {
    setTimeout(() => {
      window.addEventListener('click', onWindowClick)
    })

    return () => {
      window.removeEventListener('click', onWindowClick)
    }
  }, [])

  return (
    <div>
      {buttons.map((
        Button,
        i // eslint-disable-next-line
      ) => (
        <Button key={i} {...props} />
      ))}
    </div>
  )
}

export default HeadlinesPicker
